// extracted by mini-css-extract-plugin
export default {"titleText":"CustomerService_titleText__Mbca6","collapseContainer":"CustomerService_collapseContainer__vcgV8"};